import * as Blockly from 'blockly/core';

/**
 * Canvas snapshot for the AI assistant and for persistence.
 * Wraps Blockly's JSON serialization with AI-friendly enrichment.
 */

export interface CanvasSnapshot {
  version: 1;
  blocks: Record<string, unknown>[];
  variables: Record<string, unknown>[];
}

interface SerializedState {
  blocks?: { blocks?: Record<string, unknown>[] };
  variables?: Record<string, unknown>[];
}

export function buildSnapshot(workspace: Blockly.Workspace): CanvasSnapshot {
  const state = Blockly.serialization.workspaces.save(workspace) as SerializedState;
  const topBlocks = state.blocks?.blocks ?? [];

  // Attach live coordinates for top-level blocks so the model can reason about layout.
  const positioned = topBlocks.map((entry) => {
    const id = entry['id'] as string | undefined;
    if (!id) return entry;
    const live = workspace.getBlockById(id);
    if (!live) return entry;
    const xy = live.getRelativeToSurfaceXY();
    return { ...entry, x: Math.round(xy.x), y: Math.round(xy.y) };
  });

  return {
    version: 1,
    blocks: positioned,
    variables: state.variables ?? [],
  };
}

export function loadSnapshot(workspace: Blockly.Workspace, snapshot: CanvasSnapshot): void {
  Blockly.serialization.workspaces.load(
    { blocks: { blocks: snapshot.blocks, variables: snapshot.variables } },
    workspace,
  );
}
